import { ref } from 'vue'
import { projectFirestore } from '../firebase/config'

const getMentees = () => {
	const mentees = ref([])
	const error = ref(null)

	const load = async () => {
		try {
			const res = await projectFirestore.collection('mentees')
			.orderBy('created-at', 'desc')
			.onSnapshot(snap => {
				let docs = snap.docs.map(doc => {
					return { ...doc.data(), id: doc.id }
				})
				mentees.value = docs
			})

		}
		catch (err){
			error.value = err.message
			console.log(error.value)
		}
	}

	return { mentees, error, load }
}

export default getMentees